import { Permissions, usePermission } from 'src/rbac';

/**
 * May this user edit availability? Drives the "Edit My Availability" / "Edit Availability"
 * button's disabled state on the My-Availability calendar toolbar.
 *
 * Migrated (Segment B) from the legacy `permissionData.includes('Update Availability')`
 * display-name check to the instrumented `Permissions.UPDATE_AVAILABILITY` scopeKey. The catalog
 * display name equals the legacy paths.ts string (parity-verified in rbac-parity.test.ts), so
 * behavior is preserved; the check now emits RUM telemetry.
 */
export function useUpdateAvailabilityGate(): boolean {
  return usePermission(Permissions.UPDATE_AVAILABILITY);
}
